import React, {useState} from 'react';
import { Checkbox, ColorPicker, MessageBar, MessageBarType, Depths, IconButton, Label, Panel, PanelType, Persona, PrimaryButton, TextField, getTheme, Slider, Dropdown, FontIcon, Facepile, PersonaCoin, PersonaSize, DefaultButton } from '@fluentui/react';
import axios from 'axios';
import { Badge, Button, ButtonGroup, Table } from 'react-bootstrap';

export const Projects = (props) => {
  const { projects, setProjects, projectMembers=[] } = props;
  const [shownewProjectPanel, toggleshownewProjectPanel] = React.useState(false);
  const [newProject, setnewProject] = React.useState({
    name: '', 
    pm: "", 
    type: 'Project', 
    status: "Active", 
    probability: 1, 
    color: getTheme().palette.green, 
    members: []
  });

  const [editProjectState, setEditProject] = React.useState(null);
  const [errorMessage, setErrorMessage] = useState(null);
  const [successMessage, setSuccessMessage] = useState(null);
  const [showAddPersons, toggleShowAddPersons] = React.useState(false);

  const addProject = async () => {
    try {
      const response = await axios.post("/api/create-project", {
        name: newProject.name,
        type: newProject.type,
        status: newProject.status,
        probability: newProject.probability,
        color: newProject.color,
        members: newProject.members,
        pm: newProject.pm
      });
      setSuccessMessage(response.data.message || "Project created successfully!");
      setnewProject({name: '', type: 'Project', status: "Active", probability: 1, color: getTheme().palette.green, members: [], pm: ""});
      props.fetchProjects();
      props.fetchProjectMembers();
    } catch (error) {
      setErrorMessage(error.response?.data?.error || "An error occurred while creating the project.");
    }
  };

  const deleteProject = async (id) => {
    try {
      const response = await axios.delete(`/api/project/${id}`, null, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('wlp-token')}`,
        },
      });
      if(response.status === 200){
        setEditProject(null);
        props.fetchProjectMembers();
        props.fetchProjects();
      }
    } catch(err) {
      setErrorMessage("Unable to delete project.");
      console.log(err);
    }
  }

  const editProject = async () => {
    try {
      const response = await axios.put("/api/edit-project", {
        id: editProjectState.id,
        name: editProjectState.name,
        type: editProjectState.type,
        status: editProjectState.status,
        probability: editProjectState.probability,
        color: editProjectState.color,
        members: editProjectState.members,
        pm: editProjectState.pm
      });

      // console.log(response);

      setSuccessMessage(response.data.message || "Project updated successfully!");
      props.fetchProjectMembers();
      props.fetchProjects();
      setEditProject(null);

    } catch (error) {

      setErrorMessage(error.response?.data?.error || "An error occurred while updating the project.");
    }
  };

  const toggleMemberProject = (memberId, checked) => {
    setnewProject(prev => ({...prev,
      members: checked ? prev.members.concat(memberId) : prev.members.filter(el => el !== memberId)
    }))
  };

  const messages = React.useMemo(() => {
    return <div>
      {errorMessage && (
        <MessageBar messageBarType={MessageBarType.error} isMultiline={false}>
          {errorMessage}
        </MessageBar>
      )}
      {successMessage && (
        <MessageBar messageBarType={MessageBarType.success} isMultiline={false}>
          {successMessage}
        </MessageBar>
      )}
    </div>
  }, [errorMessage, successMessage]);

  return <div className='mt-4'>
    <h2>
      Projects
      <IconButton 
        styles={{
          root: {marginLeft: 16, background: getTheme().palette.themeSecondary, borderRadius: '50%', color: "#fff"},
          rootHovered: {background: getTheme().palette.themePrimary, color: "#fff", boxShadow: Depths.depth16}
        }} 
        iconProps={{iconName: "Add"}} onClick={() => {
          toggleshownewProjectPanel(true);
          setnewProject(prev => ({...prev, type: 'Project'}))
        }} />
    </h2>
    <Table size="sm" hover>
      <thead>
        <tr>
          <th style={{width: 32}}></th>
          <th style={{width: 300}}>Name</th>
          <th style={{width: 120}}>Probability</th>
          <th style={{width: 120}}>Status</th>
          <th style={{width: 160}}>PM</th>
          <th>Team</th>
        </tr>
      </thead>
      <tbody>
        {
          projects.map(proj => {
            if(proj.type === 'Other') return null;
            let mems = projectMembers.filter(el => el.project_id === proj.id).map(({member_id}) => props.members.find(el => el.id === member_id));
            return <tr key={proj.id}>
              <td style={{verticalAlign: 'middle'}}>
                <IconButton 
                  iconProps={{iconName: "Edit"}} 
                  styles={{root: {background: proj.color, color: '#fff'}}} 
                  onClick={() => setEditProject(prev => ({...proj, members: mems.map(m => m.id)}))} />
              </td>
              <td style={{verticalAlign: 'middle'}}>
                {proj.name}
              </td>
              <td style={{verticalAlign: 'middle'}}>
                {`${Math.round(proj.probability*100)}%`}
              </td>
              <td style={{verticalAlign: 'middle'}}>
                <Badge variant={proj.status === 'Active' ? 'success' : proj.status === 'Archived' ? 'secondary' : 'warning'}>
                  {proj.status}
                </Badge>

              </td>
              <td style={{verticalAlign: 'middle'}}>
                {proj.pm}
              </td>
              <td style={{verticalAlign: 'middle'}}>
                <Facepile
                  showTooltip={false}
                  maxDisplayablePersonas={props.members.length}
                  onRenderPersona={(props) => <PersonaCoin size={PersonaSize.size32} text={props.personaName} {...props} />}
                  personas={mems.map(m => ({key: m.id, personaName: m.name}))} />
              </td>
            </tr>
          })
        }
      </tbody>
    </Table>
    <h2>
      Other
      <IconButton 
        styles={{
          root: {marginLeft: 16, background: getTheme().palette.themeSecondary, borderRadius: '50%', color: "#fff"},
          rootHovered: {background: getTheme().palette.themePrimary, color: "#fff", boxShadow: Depths.depth16}
        }} 
        iconProps={{iconName: "Add"}} onClick={() => {
          toggleshownewProjectPanel(true);
          setnewProject(prev => ({...prev, type: 'Other'}))
        }} />
    </h2>
    <Table size="sm" hover>
      <thead>
        <tr>
          <th style={{width: 32}}></th>
          <th style={{width: 300}}>Name</th>
          <th style={{width: 120}}>Probability</th>
          <th style={{width: 120}}>Status</th>
          <th style={{width: 160}}>PM</th>
          <th>Team</th>
        </tr>
      </thead>
      <tbody>
        {
          projects.map(proj => {
            if(proj.type === 'Project') return null;
            let mems = projectMembers.filter(el => el.project_id === proj.id).map(({member_id}) => props.members.find(el => el.id === member_id));
            return <tr key={proj.id}>
              <td style={{verticalAlign: 'middle'}}>
                <IconButton 
                  iconProps={{iconName: "Edit"}} 
                  styles={{root: {background: proj.color, color: '#fff'}}} 
                  onClick={() => setEditProject(prev => ({...proj, members: mems.map(m => m.id)}))} />
              </td>
              <td style={{verticalAlign: 'middle'}}>
                {proj.name}
              </td>
              <td style={{verticalAlign: 'middle'}}>
                {`${Math.round(proj.probability*100)}%`}
              </td>
              <td style={{verticalAlign: 'middle'}}>
                <Badge variant={proj.status === 'Active' ? 'success' : proj.status === 'Archived' ? 'secondary' : 'warning'}>
                  {proj.status}
                </Badge>

              </td>
              <td style={{verticalAlign: 'middle'}}>
                {proj.pm}
              </td>
              <td style={{verticalAlign: 'middle'}}>
                {
                  mems.length === props.members.length ? "All Members" : <Facepile
                  showTooltip={false}
                  maxDisplayablePersonas={props.members.length}
                  onRenderPersona={(props) => <PersonaCoin size={PersonaSize.size32} text={props.personaName} {...props} />}
                  personas={mems.map(m => ({key: m.id, personaName: m.name}))} />
                }
                
              </td>
            </tr>
          })
        }
      </tbody>
    </Table>



    <Panel isLightDismiss styles={{commands: {zIndex: `2 !important`}}} headerText='Create Project' type={PanelType.medium} isOpen={shownewProjectPanel} onDismiss={() => toggleshownewProjectPanel(false)}>
      {messages}
      <TextField styles={{root: {marginBottom: 16}}} value={newProject.name} onChange={(e, val) => setnewProject(prev => ({...prev, name: val}))} label='Name' />



      <Dropdown 
        styles={{root: {marginBottom: 16}}} 
        selectedKey={newProject.pm} 
        options={props.members.map(el => ({key: el.name, text: el.name}))}
        onChange={(e, o) => {
          let pm = props.members.find(el => el.name === o.key);
          setnewProject(prev => ({
            ...prev, 
            pm: o.key,
            members: prev.members.includes(pm.id) ? prev.members : prev.members.concat(pm.id)
          }))
        }} 
        label='Project Manager' />

      <Label>Status</Label>
      <ButtonGroup className='mb-3'>
        {
          ["Active", 'On Hold', 'Archived'].map((el) => {
            let active = el === newProject.status;
            return <Button key={el} onClick={() => setnewProject(prev => ({...prev, status: el}))} variant={active ? newProject.status === 'Active' ? 'success' : newProject.status === 'On Hold' ? 'warning' : 'secondary' : 'light'} active={el === newProject.status}>{el}</Button>
          })
        }
      </ButtonGroup>
      

      <Slider 
        label='Probability' 
        min={0} 
        max={1} 
        step={0.05} 
        styles={{slideBox: {height: 24}}}
        value={newProject.probability} 
        valueFormat={(val) => `${val * 100}%`} 
        onChange={(val) => setnewProject(prev => ({...prev, probability: val}))} />

      <Label>Color</Label>
      <ColorPicker 
        alphaType='none'
        color={newProject.color} 
        onChange={(e, col) => setnewProject(prev => ({...prev, color: col.str}))} />

      
      <Label>Team</Label>
      {
        props.members.map(member => {
          return <Checkbox 
            key={member.id}
            label={member.name} 
            onRenderLabel={(props) => {
              return <div style={{display: 'flex', gap: '1em'}}>
                <span>{props.label}</span>
                {
                  member.name === newProject.pm && <FontIcon iconName='StarburstSolid' style={{color: getTheme().palette.yellowDark}} />
                }
              </div>
            }} 
            checked={newProject.members.includes(member.id)}
            onChange={(e, checked) => toggleMemberProject(member.id, checked)}/>
        })
      }
      <PrimaryButton styles={{root: {marginTop: 32}}} text="Add Project" disabled={!newProject.name} onClick={addProject} />
    </Panel>


    {editProjectState && <Panel isLightDismiss styles={{commands: {zIndex: `2 !important`}}} headerText='Edit Project' type={PanelType.medium} isOpen={editProjectState} onDismiss={() => setEditProject(null)}>

      {messages}
      
      <TextField styles={{root: {marginBottom: 16}}} value={editProjectState.name} onChange={(e, val) => setEditProject(prev => ({...prev, name: val}))} label='Name' />

      <Dropdown 
        styles={{root: {marginBottom: 16}}} 
        selectedKey={editProjectState.pm} 
        options={props.members.map(el => ({key: el.name, text: el.name}))}
        onChange={(e, o) => {
          let pm = props.members.find(el => el.name === o.key);
          setEditProject(prev => ({
            ...prev, 
            pm: o.key,
            members: prev.members.includes(pm.id) ? prev.members : prev.members.concat(pm.id)
          }))
        }} 
        label='Project Manager' />

      <Label>Status</Label>
      <ButtonGroup className='mb-3'>
        {
          ["Active", 'On Hold', 'Archived'].map((el) => {
            let active = el === editProjectState.status;
            return <Button key={el} onClick={() => setEditProject(prev => ({...prev, status: el}))} variant={active ? editProjectState.status === 'Active' ? 'success' : editProjectState.status === 'On Hold' ? 'warning' : 'secondary' : 'light'} active={el === editProjectState.status}>{el}</Button>
          })
        }
      </ButtonGroup>

      <Slider 
        label='Probability' 
        min={0} 
        max={1} 
        step={0.05} 
        value={editProjectState.probability}
        valueFormat={(val) => `${val * 100}%`} 
        onChange={(val) => setEditProject(prev => ({...prev, probability: val}))} />

      

      <Label>Color</Label>
      <ColorPicker 
        alphaType='none'
        color={editProjectState.color} 
        onChange={(e, col) => setEditProject(prev => ({...prev, color: col.str}))} />

      <Label>Team</Label>
      {
        props.members.map(member => {
          return <Checkbox 
            label={member.name}
            key={member.id}
            onRenderLabel={(props) => {
              return <div style={{display: 'flex', gap: '1em'}}>
                <span>{props.label}</span>
                {
                  member.name === editProjectState.pm && <FontIcon iconName='StarburstSolid' style={{color: getTheme().palette.yellowDark}} />
                }
              </div>
            }}
            checked={editProjectState.members.includes(member.id)}
            onChange={(e, checked) => {
              setEditProject(prev => ({
                ...prev,
                members: checked ? prev.members.concat(member.id) : prev.members.filter(el => el !== member.id)
              }))
            }}/>
        })
      }
      <div style={{marginTop: 32, display: 'flex', justifyContent: 'space-between'}}>
        <PrimaryButton text="Edit Project" disabled={!editProjectState.name} onClick={editProject} />
        <DefaultButton text="Delete Project" onClick={() => deleteProject(editProjectState.id)} />
      </div>
    </Panel>}


    
  </div>
}